import React from "react";

const DeleteTask = (props) => {
  const { showDelModal, setShowDelModal, handleConfirm, handleCancel } = props;

  const handleBackdropClick = () => {
    setShowDelModal(false);
  };

  const handleConfirmClick = () => {
    handleConfirm();
  }

  const handleCancelClick = () => {
    handleCancel();
  }

  return (
    <>
      {showDelModal && (
        <div
          data-dialog-backdrop="dialog-md"
          data-dialog-backdrop-close="true"
          className="fixed inset-0 z-[999] grid h-screen w-screen place-items-center bg-black bg-opacity-50 backdrop-blur-sm transition-opacity duration-300"
          onClick={handleBackdropClick}
        >
          <div
            data-dialog="dialog-md"
            className="relative m-4 p-8 w-2/5 rounded-lg bg-white shadow-sm"
            onClick={(e) => e.stopPropagation()} // Prevent closing on dialog click
          >
            <h2 className="text-2xl font-semibold mb-2 text-center">
              Are you sure ?
            </h2>
            <hr className="w-full border-t-1 border-[#0083BF] mb-6" />
            <div className="text-center mb-2">
              This task will be deleted immediately . You can't undo this
              action.
            </div>
            <div className="flex justify-center w-full gap-4">
              <button
                className="py-1 px-4 bg-gray-200 text-gray-700 rounded-md"
                onClick={handleCancelClick}
              >
                No
              </button>
              <button
                className="py-1 px-4 bg-[#0083BF] text-white rounded-md"
                onClick={handleConfirmClick}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteTask;
